import * as Sentry from '@sentry/react';

import { sendException } from '../../../utils/sentry';

import { FallbackComponent } from './FallBackComponent';

export const ErrorBoundary = (props: Sentry.ErrorBoundaryProps) => {
  return (
    <Sentry.ErrorBoundary
      fallback={props.fallback || FallbackComponent}
      onError={(err) => {
        // send whitescreen message to sentry
        sendException(err, { tags: [['action', 'WHITESCREEN']] });
      }}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
};
